/**
 * Emulate a full ES2015+ environment (no < Stage 4 proposals).
 */

import 'core-js/stable';
import 'regenerator-runtime/runtime';

/**
 * include lazy load
 */
import LazyLoad from "vanilla-lazyload";
const myLazyLoad = new LazyLoad({
    elements_selector: ".lazy-load"
});


/**
 * include tiny slider
 */
import { tns } from "tiny-slider"
if($('ul').is('#mycarouselll')){
    const slider = tns({
        container: '#mycarouselll',
        items: 1,
        slideBy: 'page',
        controlsText: ['<span class="arrows">&#8249;</span>', '<span class="arrows">&#8250;</span>'],
        autoplay: true,
        autoplayButtonOutput: false
    });
}